import { render, staticRenderFns } from "./CookiePreferences.vue?vue&type=template&id=49e90cc4&scoped=true"
import script from "./CookiePreferences.vue?vue&type=script&lang=js"
export * from "./CookiePreferences.vue?vue&type=script&lang=js"
import style0 from "./CookiePreferences.vue?vue&type=style&index=0&id=49e90cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e90cc4",
  null
  
)

export default component.exports